import ArrowLeft from '@assets/icons/arrow-left.svg'
import { useTranslation } from 'react-i18next'

import { useLoading } from '@/hooks/useLoading'
import { useNavigate } from '@/hooks/useNavigate'
import { useReminder } from '@/hooks/useReminder'
import { useStep } from '@/hooks/useStep'
import { BACK_TYPE } from '@/types/step'

export const BackButton = () => {
  const { t } = useTranslation()
  const { navigateBack } = useNavigate()
  const { setReminderSet } = useReminder()
  const { loading, showLoading, hideLoading } = useLoading()
  const { currentStep } = useStep()

  return (
    <button
      data-testid="back-button"
      title={t('back') || 'back'}
      className="flex items-center gap-2 text-white disabled:opacity-50"
      disabled={loading}
      onClick={async () => {
        showLoading()
        setReminderSet(false)

        try {
          await navigateBack()
        } finally {
          hideLoading()
        }
      }}
    >
      <img src={ArrowLeft} className="h-5" />
      {currentStep?.backButton === BACK_TYPE.LONG && <span className="ml-2 text-white">{t('back')}</span>}
    </button>
  )
}
